module.exports = __webpack_public_path__ + "static/media/DH_02.a6a0ff49.jpg";